import DeleteConfirmation from "components/ui/DeleteConfirmation";
import { useDeletePaymentReconMain } from "http-hooks/paymentreconmain/paymentreconmain";

export default function DeletePaymentRecon({ id, onClose }) {
  const { mutateAsync, isPending } = useDeletePaymentReconMain();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Payment Reconciliation"
      description="Are you sure you want to delete this payment reconciliation? All associated document adjustment flags will be reset. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}

